import CheckLuhn from "../../../../utils/Luhn";
import { findCardType } from "../../../../utils/BinUtils";

export default number => {
  const trimmedNumber = number.replace(/\s+/g, "");
  if (trimmedNumber.length === 0) {
    return { showError: true, errorMsg: undefined };
  }
  const cardType = findCardType(number);
  const getCardLength = () => {
    if (cardType === "DINERS") {
      return 14;
    }
    if (cardType === "AMEX") {
      return 15;
    }
    return 16;
  };

  if (!CheckLuhn(trimmedNumber) || trimmedNumber.length < getCardLength) {
    return { showError: true, errorMsg: "Invalid card number" };
  }
  return { showError: false, errorMsg: undefined };
};
